import config from "../../../config";

export default {
    /**
     * Get RegEx invalid characters array
     */
    getInvalidCharacters: (regex: RegExp, value: string) => {
        const next = [];
        for (let i = 0; i < value.length; i++) {
            !regex.test(value[i]) && next.push(value[i]);
        }
        return next;
    },
    /**
     * Parse RegEx String
     * @description Parse quoted regex string "/regex/" -> /regex/
     */
    parseString: (regex: string) => {
        if (regex) {
            const parts = /\/(.*)\/(.*)/.exec(regex);
            if (parts && parts.length > 0) {
                return new RegExp(parts[1], parts[2] || "");
            }
        }
        return null;
    },
    /**
     * Get Search Text RegExp
     * @description "A B C D" => /(A|B|C|D)/ig
     * @param {string} value
     */
    searchText: (value: string) => {
        let next = value.trim();
        next = next.replace(config.regex.escapeCharacters, "\\$&");
        next = next.replace(/\s+/g, "|");
        next = `(${next})`;
        return new RegExp(next, "ig");
    }
};
